"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullVisualizationCatalog = exports.DefaultVisualizationCatalog = exports.CatalogViaTypeToClassMap = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2021 GoodData Corporation
var last_1 = tslib_1.__importDefault(require("lodash/last"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var AreaChartDescriptor_1 = require("./pluggableVisualizations/areaChart/AreaChartDescriptor");
var BarChartDescriptor_1 = require("./pluggableVisualizations/barChart/BarChartDescriptor");
var BubbleChartDescriptor_1 = require("./pluggableVisualizations/bubbleChart/BubbleChartDescriptor");
var BulletChartDescriptor_1 = require("./pluggableVisualizations/bulletChart/BulletChartDescriptor");
var ColumnChartDescriptor_1 = require("./pluggableVisualizations/columnChart/ColumnChartDescriptor");
var ComboChartDescriptor_1 = require("./pluggableVisualizations/comboChart/ComboChartDescriptor");
var ComboChartDescriptorDeprecated_1 = require("./pluggableVisualizations/comboChart/ComboChartDescriptorDeprecated");
var DonutChartDescriptor_1 = require("./pluggableVisualizations/donutChart/DonutChartDescriptor");
var FunnelChartDescriptor_1 = require("./pluggableVisualizations/funnelChart/FunnelChartDescriptor");
var HeadlineDescriptor_1 = require("./pluggableVisualizations/headline/HeadlineDescriptor");
var HeatmapDescriptor_1 = require("./pluggableVisualizations/heatMap/HeatmapDescriptor");
var LineChartDescriptor_1 = require("./pluggableVisualizations/lineChart/LineChartDescriptor");
var PieChartDescriptor_1 = require("./pluggableVisualizations/pieChart/PieChartDescriptor");
var PivotTableDescriptor_1 = require("./pluggableVisualizations/pivotTable/PivotTableDescriptor");
var ScatterPlotDescriptor_1 = require("./pluggableVisualizations/scatterPlot/ScatterPlotDescriptor");
var TreemapDescriptor_1 = require("./pluggableVisualizations/treeMap/TreemapDescriptor");
var XirrDescriptor_1 = require("./pluggableVisualizations/xirr/XirrDescriptor");
var GeoPushpinChartDescriptor_1 = require("./pluggableVisualizations/geoChart/GeoPushpinChartDescriptor");
/**
 * @internal
 */
var CatalogViaTypeToClassMap = /** @class */ (function () {
    function CatalogViaTypeToClassMap(mapping) {
        this.mapping = mapping;
    }
    CatalogViaTypeToClassMap.prototype.forUri = function (uri) {
        var VisType = this.findInMapping(uri);
        if (!VisType) {
            throw new sdk_ui_1.UnexpectedSdkError("Unknown visualization class URI: " + uri);
        }
        return new VisType();
    };
    CatalogViaTypeToClassMap.prototype.hasDescriptorForUri = function (uri) {
        return !!this.findInMapping(uri);
    };
    CatalogViaTypeToClassMap.prototype.forInsight = function (insight) {
        /*
         * the URIs follow "local:visualizationType" format
         */
        var visClassUri = sdk_model_1.insightVisualizationUrl(insight);
        return this.forUri(visClassUri);
    };
    CatalogViaTypeToClassMap.prototype.hasDescriptorForInsight = function (insight) {
        var visClassUri = sdk_model_1.insightVisualizationUrl(insight);
        return this.hasDescriptorForUri(visClassUri);
    };
    CatalogViaTypeToClassMap.prototype.findInMapping = function (uri) {
        var split = uri.split(":");
        var key = last_1.default(split);
        return this.mapping[key];
    };
    return CatalogViaTypeToClassMap;
}());
exports.CatalogViaTypeToClassMap = CatalogViaTypeToClassMap;
//
// Default static catalog implementation
//
/**
 * Compile-time pluggable visualization 'catalog'.
 */
var DefaultVisualizations = {
    bar: BarChartDescriptor_1.BarChartDescriptor,
    bullet: BulletChartDescriptor_1.BulletChartDescriptor,
    column: ColumnChartDescriptor_1.ColumnChartDescriptor,
    line: LineChartDescriptor_1.LineChartDescriptor,
    area: AreaChartDescriptor_1.AreaChartDescriptor,
    pie: PieChartDescriptor_1.PieChartDescriptor,
    donut: DonutChartDescriptor_1.DonutChartDescriptor,
    table: PivotTableDescriptor_1.PivotTableDescriptor,
    headline: HeadlineDescriptor_1.HeadlineDescriptor,
    scatter: ScatterPlotDescriptor_1.ScatterPlotDescriptor,
    bubble: BubbleChartDescriptor_1.BubbleChartDescriptor,
    heatmap: HeatmapDescriptor_1.HeatmapDescriptor,
    combo: ComboChartDescriptorDeprecated_1.ComboChartDescriptorDeprecated,
    combo2: ComboChartDescriptor_1.ComboChartDescriptor,
    treemap: TreemapDescriptor_1.TreemapDescriptor,
    funnel: FunnelChartDescriptor_1.FunnelChartDescriptor,
    pushpin: GeoPushpinChartDescriptor_1.GeoPushpinChartDescriptor,
};
/**
 * Default pluggable visualization catalog. This is implemented using static lookup table between vis type
 * and the actual plug vis implementation.
 *
 * @alpha
 */
exports.DefaultVisualizationCatalog = new CatalogViaTypeToClassMap(DefaultVisualizations);
/**
 * Pluggable visualization catalog containing all available visualizations.
 *
 * @alpha
 */
exports.FullVisualizationCatalog = new CatalogViaTypeToClassMap(tslib_1.__assign(tslib_1.__assign({}, DefaultVisualizations), { xirr: XirrDescriptor_1.XirrDescriptor }));
//# sourceMappingURL=VisualizationCatalog.js.map